import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Tooltip } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Checkbox from '@mui/material/Checkbox';
import { DownloadStudentTransferReport } from '../../services/DownloadCsvReportsService';
import { Label } from '@mui/icons-material';
import { StudentCheckAll, StudentTransferData, StudentTransferIsCheck, StudentTransferShowdata } from '../../services/LoginPageService';

const TransferView = ({open, setOpen,rows,setRows,location,branch,specialization,semester,section,semesterTo ,sectionTo,}) => {
   
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [checked,setChecked] =useState(false);
  
    const columns = [
        {
            field: 'studentId',
            headerClassName: 'super-app-theme--header',
            headerName: 'Campus Id',
            minWidth: 90, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'registrationNo',
            headerClassName: 'super-app-theme--header',
            headerName: 'Registration No',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'studentName',
            headerClassName: 'super-app-theme--header',
            headerName: 'Student Name',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'location',
            headerClassName: 'super-app-theme--header',
            headerName: 'Location',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'branch',
            headerClassName: 'super-app-theme--header',
            headerName: 'Hostel Name',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'specialization',
            headerClassName: 'super-app-theme--header',
            headerName: 'Specialization',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'semester',
            headerClassName: 'super-app-theme--header',
            headerName: 'Semester',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'section',
            headerClassName: 'super-app-theme--header',
            headerName: 'Section',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'gender',
            headerClassName: 'super-app-theme--header',
            headerName: 'Gender',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'studentContactNo',
            headerClassName: 'super-app-theme--header',
            headerName: 'Student Contact No',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'emailId',
            headerClassName: 'super-app-theme--header',
            headerName: 'Email Id',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'parentsNo',
            headerClassName: 'super-app-theme--header',
            headerName: 'Parents No',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'parentsEmailId',
            headerClassName: 'super-app-theme--header',
            headerName: 'Parents Email Id',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'altContactNo',
            headerClassName: 'super-app-theme--header',
            headerName: 'Alternate No',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'rfid',
            headerClassName: 'super-app-theme--header',
            headerName: 'RFID',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            headerClassName: 'super-app-theme--header',
            width: 250,
            cellClassName: 'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                <CheckedList selectedRow={params.row}/>
             
            ],
          },
    ];
    function CheckedList({ selectedRow }){
        return(
            <Tooltip title="Check">
            <Checkbox {...Label}  checked={selectedRow?.isCheck === '1' ? true : false}
            onClick={() => {
                StudentTransferIsCheck({
                    id:selectedRow?.id
                },handleStudentIsCheck,handleStudentIsCheckException)
              
            }
            }/>
        </Tooltip>
        )
    }

    const handleStudentIsCheck =()=> {
        StudentTransferShowdata({
            location: location,
            branch  : branch,
            specialization:specialization,
            semester:semester,  
            section:section,
        },handleViewTransferShowdata,handleViewTransferShowdataException);
    }
    
    const handleViewTransferShowdata= (dataObject) =>{
        setRows(dataObject?.message);
    }

    const handleViewTransferShowdataException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }

    
    const handleStudentIsCheckException =()=>{
    }
  

    const handleClose = () => {
        setOpen(false); 
    };

    const onClickDownloadStudent=()=>{
        DownloadStudentTransferReport({
            location :location,
            branch : branch, 
            specialization: specialization ,
            semester: semester ,  
            section: section,
        },handleStudentTransferDownload,handleStudentTransferDownloadException);
    }

    const handleStudentTransferDownload =()=> {
    }
    
    const handleStudentTransferDownloadException =()=>{
    }
  
    const handleChange=()=>{
        StudentCheckAll({
            location :location,
            branch : branch, 
            specialization: specialization ,
            semester: semester ,  
            section: section,
        },handleStudentCheckAll,handleStudentCheckAllException);
    }
    
    
    const handleStudentCheckAll =(dataObject)=> {
        if(dataObject?.data ==='1')
        {
            setChecked(true)
        }else{
            setChecked(false)
        }
        StudentTransferShowdata({
            location: location,
            branch  : branch,
            specialization:specialization,
            semester:semester,  
            section:section,
        },handleViewTransferShowdata,handleViewTransferShowdataException);
    }
    
    const handleStudentCheckAllException =()=>{
    }
  
    return (
        <div>
            <Dialog sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '100%' } }}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            fullScreen
            fullWidth >
                <DialogTitle style={{background:'#f7f7f7',color:'black'}}>
                    Student List
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} >
                        <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1} mt={1}>
                            <Grid item>
                                <FormControlLabel
                                    label="Select All"
                                    control={
                                    <Checkbox
                                    checked={checked}
                                    onChange={handleChange}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    />}
                                />
                            </Grid>
                        </Grid>  
                        <Grid item xs={12} sm={12} md={12} lg={12} lx={12}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                pageSize={8}
                                rowsPerPageOptions={[8]}
                                disableSelectionOnClick
                                sx={{
                                height: '480px',
                                width: '100%',
                                '& .super-app-theme--header': {
                                    WebkitTextStrokeWidth:'0.6px',
                                },
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={1} mt={1}>
                        <Grid item>
                            <Button variant="contained" onClick={onClickDownloadStudent}>DownLoad</Button>
                        </Grid>
                        <Grid item>
                            <Button  variant="contained" autoFocus onClick={handleClose}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>   
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default TransferView
